import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { useAuth } from '../../contexts/AuthContext';
import { login } from '../../services/api';
import ErrorCard from '../../components/ErrorCard/ErrorCard';
import DarkModeToggle from '../../components/DarkModeToggle/DarkModeToggle';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [errorMessage, setErrorMessage] = useState('');
  const { handleRequest, loading } = useApi();
  const { checkAuth } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await handleRequest(login, formData);
      await checkAuth();
      navigate('/dashboard', { replace: true });
    } catch (error) {
      setErrorMessage(error.message || 'Innlogging mislyktes. Prøv igjen.');
    }
  };

  return (
    <div className="login-container">
      <div className="dark-mode-toggle-wrapper">
        <DarkModeToggle />
      </div>
      <div className="login-card">
        <h2>Logg inn</h2>
        {errorMessage && (
          <ErrorCard 
            message={errorMessage} 
            onClose={() => setErrorMessage('')}
          />
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="E-post"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Passord"
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Laster...' : 'Logg inn'}
          </button>
        </form>
        <div className="auth-links">
          <p className="auth-link">
            Er du lærer? <Link to="/register">Registrer deg her</Link>
          </p>
          <p className="auth-link">
            Er du elev? <Link to="/join">Bli med i en klasse</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login; 